import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import {
  ErrorResponseModel,
  PatientBehaviorType,
  GraphAnnotationType,
  TargetType,
  UserModel,
} from './api/models';

export class Utils {

  static beep() {
    console.debug('Beep');
    try {
      var snd = new Audio("data:audio/wav;base64,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");
      snd.play();
    } catch (ex) {
      console.error(ex);
    }
  }

  static graphAnnotationTypeLabel(option: GraphAnnotationType) {
    switch (option) {
      case GraphAnnotationType.YAxis:
        return 'Y Axis';
      case GraphAnnotationType.XAxis:
        return 'X Axis';
      case GraphAnnotationType.YAxisRange:
        return 'Y Axis Range';
      case GraphAnnotationType.XAxisRange:
        return 'X Axis Range';
      case GraphAnnotationType.Point:
        return 'Point';
      case GraphAnnotationType.Text:
        return 'Text';
      case GraphAnnotationType.Image:
        return 'Image';
      default:
        return 'default';
    }
  }
  static patientBehaviorTypeLabel(option: PatientBehaviorType) {
    switch (option) {
      case 1:
        return 'Frequency';
      case 2:
        return 'Duration';
      case 3:
        return 'Interval';
      case 4:
        return 'Rate Timer';
      default:
        return 'default';
    }
  }

  // date helpers
  static dateInPastBy(numberOfDays: number, date?: Date): Date {
    if (!date) date = new Date();
    date.setDate(date.getDate() - numberOfDays);
    return date;
  }

  static daysToBeginningOfMonth(date?: Date) {
    if (!date) date = new Date();

    return Math.floor(
      (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) -
        Date.UTC(date.getFullYear(), date.getMonth(), 1)) /
      (1000 * 60 * 60 * 24)
    );
  }

  static daysToBeginningOfYear(date?: Date) {
    if (!date) date = new Date();

    return Math.floor(
      (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) -
        Date.UTC(date.getFullYear(), 0, 1)) /
      (1000 * 60 * 60 * 24)
    );
  }

  static formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    const secsStr = secs.toString().padStart(2, '0');

    return `${hoursStr}:${minutesStr}:${secsStr}`;
  }

  static getDateWithOffset(offset: number) {
    let tomorrow = new Date();
    tomorrow.setHours(0);
    tomorrow.setMinutes(0);
    tomorrow.setSeconds(0);
    tomorrow.setDate(new Date().getDate() + offset);
    return tomorrow;
  }

  static dateStringIsBefore(dateBefore?: string | null, dateAfter?: string | null, allowEqualTo?: boolean) : Boolean {
    if (!dateBefore || !dateAfter) {
      return false;
    }

    let firstDate = this.formatDateForSorting(dateBefore);
    let secondDate = this.formatDateForSorting(dateAfter);

    if (allowEqualTo) {
      return firstDate <= secondDate;
    }

    return firstDate < secondDate;
  }

  static formatDateForSorting(dateObject: any): string {
    if (dateObject == null || !this.isDateValid(dateObject)) {
      return "";
    }

    if (typeof (dateObject) === 'string' && (dateObject.indexOf('T') < 0)) {
      dateObject = dateObject.replace(/-/g, "/"); //yyyy-mm-dd does not return correct date. yyyy/mm/dd, mm-dd-yyyy, and mm/dd/yyyy all do.
    }

    var date = new Date(dateObject);

    if ((typeof (dateObject) === 'string') && (dateObject.indexOf('T') > 0)) {
      var s = dateObject.split('T').slice(0, -1);
      date = new Date(s[0]);
      if (date.getHours() > 0 && this.getTimezoneOffsetString().indexOf('-') > -1) { //can I test with + timezone?
        date.setHours(0);
        date.setDate(date.getDate() + 1);
      }
    } else {
      let parsedDate = this.parseJsonDate(dateObject);
      if (parsedDate == null) {
        return "";
      }
      date = parsedDate!;
    }

    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
    return date.getFullYear() + '/' + month + '/' + day;    
  }

  static getTimezoneOffsetString(): string {
    var d = (new Date()).toString();
    var tz = d.split("GMT");
    if (tz.length < 2) {
      return "";
    }
    return tz[1].split(" ")[0]; //i.e. -0700
  }

  static parseJsonDate(dateObject: any) : Date | null {
    try {
      if (!dateObject)
        return null;
      if ((typeof (dateObject) === 'string') && (dateObject.startsWith('/Date(')))
        return new Date(parseInt(dateObject.substr(6)));
      
      return new Date(dateObject);
    } catch (ex) {
      return null;
    }
  }

  static isDateValid(dateObject: any) : Boolean {
    try {
      if (typeof dateObject === 'undefined' || dateObject == null || dateObject === '')
        return false;
      if ((typeof (dateObject) === 'string'))
        dateObject = new Date(dateObject);

      if (isNaN(dateObject))
        return false;
      if (dateObject.getFullYear() < 1753)
        return false;
      if (dateObject.getFullYear() > 9999)
        return false;

      return true;
    } catch (e) {
      return false
    }
  }

  static canPlotGraph(targetType: TargetType) {
    switch (targetType) {
      case TargetType.Frequency:
      case TargetType.Duration:
      case TargetType.Quantity:
			case TargetType.Currency:
      case TargetType.FluencyRate:
      case TargetType.Echoic:
      case TargetType.DiscreteTrialTeaching:
      case TargetType.GroupedFrequency:
      case TargetType.Quantity:
      case TargetType.TaskAnalysis:
      case TargetType.Toileting:
      case TargetType.WholePartialInterval:
        return true;
      default:
        return false;
    }
  }

  static patientTargetTypeLabel(option: TargetType) {
    switch (option) {
      case TargetType.Anecdotal:
        return 'Anecdotal';
      case TargetType.DiscreteTrialTeaching:
        return 'Discrete Trial Teaching';
      case TargetType.ConditionalDiscrimination:
        return 'Conditional Discrimination';
      case TargetType.Duration:
        return 'Duration';
      case TargetType.Echoic:
        return 'Echoic';
      case TargetType.FluencyRate:
        return 'Fluency Rate';
      case TargetType.Frequency:
        return 'Frequency';
      case TargetType.GroupedFrequency:
        return 'Grouped Frequency';
      case TargetType.JumpTo:
        return 'Jump To';
			case TargetType.Currency:
				return 'Currency';
      case TargetType.Quantity:
        return 'Quantity';
      case TargetType.TaskAnalysis:
        return 'Task Analysis';
      case TargetType.Toileting:
        return 'Toileting';
      case TargetType.WholePartialInterval:
        return 'Interval';
      default:
        return 'default';
    }
  }

  static getErrorMessage(validatorName: string, validatorValue: any): string {
    switch (validatorName) {
      case 'required':
        return 'This field is required.';
      case 'minlength':
        return `Minimum length is ${validatorValue.requiredLength}.`;
      case 'maxlength':
        return `Maximum length is ${validatorValue.requiredLength}.`;
      case 'email':
        return `The field shall be a valid email.`;
      // Add more cases for other validators you might have
      default:
        return `Validation failed (${validatorName}).`;
    }
  }

  static getFormErrors(form: FormGroup, parentControlName?: string): string[] {
    var errors: string[] = [];
    if (!form) return errors;
    if (!parentControlName) parentControlName = '';
    for (let controlName in form.controls) {
      let control = form.controls[controlName];
      if (control.status === 'INVALID') {
        let formArray = control as FormArray;
        if (formArray && formArray.controls && formArray.controls.length > 0) {
          for (let subFormName in formArray.controls) {
            errors.push(
              ...Utils.getFormErrors(
                formArray.controls[subFormName] as FormGroup,
                `${parentControlName}${controlName}[${subFormName}].`
              )
            );
          }
        } else {
          for (let validatorName in control.errors) {
            //errorMessages.push(Utils.getErrorMessage(validatorName, control.errors[validatorName]));
            switch (validatorName) {
              case 'required':
                errors.push(
                  `The field "${parentControlName}${controlName}" is required.`
                );
                break;
              case 'minlength':
                errors.push(
                  `The field "${parentControlName}${controlName}" minimum length is ${control.errors[validatorName].requiredLength}.`
                );
                break;
              case 'maxlength':
                errors.push(
                  `The field "${parentControlName}${controlName}" maximum length is ${control.errors[validatorName].requiredLength}.`
                );
                break;
              case 'email':
                errors.push(
                  `The field "${parentControlName}${controlName}" shall be a valid email.`
                );
                break;
              default:
                errors.push(
                  `The field "${parentControlName}${controlName}" is invalid.`
                );
            }
          }
        }
      }
    }
    return errors;
  }

  // error messages from server look like: {"Message":"Skill Area is linked to patient ...","Details":null}
  static getServerErrorMessage(error: string): string {
    // parse json string
    var errorObj = JSON.parse(error);
    if (errorObj.Message) return errorObj.Message;
    return error;
  }

  static getErrorMessageFromErrorResponse(error: ErrorResponseModel): string {
    if (typeof error === 'string') {
      error = JSON.parse(error);
    }
    return `${Utils.getErrorFromErrorResponse(
      error
    )} - Details: ${Utils.getDetailsFromErrorResponse(error)}`;
  }

  static getErrorFromErrorResponse(error: ErrorResponseModel): string {
    if (error.Message) return error.Message;
    return 'No Error Message';
  }

  static getDetailsFromErrorResponse(error: any): string {
    if (error.Details) return error.Details;
    return 'No Details';
  }

  static getAjaxError(err: any): string {
    var errMsg = 'Error';
    if (typeof err == 'string') errMsg = `${err}`;
    else {
      errMsg =
        err.error && err.error.message
          ? err.error.message
          : err.errors && err.errors.model && err.errors.model.length
            ? err.errors.model[0]
            : err.title
              ? err.title
              : err.error
                ? err.error
                : `Error performing request, status code = ${err.status} ${err.statusText}`;
      if (err.errors) {
        for (var k in err.errors) {
          if (typeof err.errors[k] == 'string') {
            errMsg = err.errors[k];
            break;
          } else if (
            err.errors[k].length &&
            typeof err.errors[k][0] == 'string'
          ) {
            errMsg = err.errors[k][0];
            break;
          }
        }
      }
    }
    return errMsg;
  }

  static getDateFromISODate(dateStr: string): Date {
    const dateSplitted = dateStr.split('-');
    return new Date(
      Number(dateSplitted[0]),
      Number(dateSplitted[1]) - 1,
      Number(dateSplitted[2])
    );
  }

  /** Format date as yyyy-MM-dd in local time for date input and for API. */
  static formatDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /** Parse yyyy-MM-dd from input as local date (avoids timezone shifting to previous day). */
  static parseDateFromInput(dateString: string): Date {
    const date = new Date(dateString);
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  }

  static deepClone(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  static getCaretPosition(editableDiv: HTMLElement) {
    var caretPos = 0,
      sel: Selection | null,
      range;
    if (window.getSelection) {
      sel = window.getSelection();
      if (sel && sel.rangeCount) {
        range = sel.getRangeAt(0);
        if (range.commonAncestorContainer.parentNode == editableDiv) {
          caretPos = range.endOffset;
        }
      }
    } else if (
      (document as any).selection &&
      (document as any).selection.createRange
    ) {
      range = (document as any).selection.createRange();
      if (range.parentElement() == editableDiv) {
        var tempEl = document.createElement('span');
        editableDiv.insertBefore(tempEl, editableDiv.firstChild);
        var tempRange = range.duplicate();
        tempRange.moveToElementText(tempEl);
        tempRange.setEndPoint('EndToEnd', range);
        caretPos = tempRange.text.length;
      }
    }
    return caretPos;
  }

  static addMinutes(date: Date, minutes: number) {
    return new Date(date.getTime() + minutes * 60000);
  }
  static parseJwt(token: string | null | undefined) {
    if (!token) return {};
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  }

}

declare global {
  interface Date {
    toISODate(): string;
    toSimpleDate(): string;
  }
}

Object.defineProperty(Date.prototype, 'toISODate', {
  value: function () {
    return (
      this.getFullYear() +
      '-' +
      ('0' + (this.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + this.getDate()).slice(-2)
    );
  },
});

Object.defineProperty(Date.prototype, 'toSimpleDate', {
  value: function () {
    return (
      ('0' + (this.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + this.getDate()).slice(-2) +
      '/' +
      this.getFullYear()
    );
  },
});
